module.exports = __webpack_public_path__ + "img/bgMain.837b5b09.png";